import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('rasheedgpt_token'));

  useEffect(() => {
    const initAuth = async () => {
      const savedToken = localStorage.getItem('rasheedgpt_token');
      if (savedToken) {
        try {
          const response = await axios.get(`${API_URL}/api/auth/me`, {
            headers: { Authorization: `Bearer ${savedToken}` }
          });
          setUser(response.data);
          setToken(savedToken);
        } catch (error) {
          localStorage.removeItem('rasheedgpt_token');
          setToken(null);
          setUser(null);
        }
      }
      setLoading(false);
    };
    
    initAuth();
  }, []);

  const login = async (username, password) => {
    try {
      const response = await axios.post(`${API_URL}/api/auth/login`, {
        username,
        password
      });
      
      const { token: newToken, user: userData } = response.data;
      localStorage.setItem('rasheedgpt_token', newToken);
      setToken(newToken);
      setUser(userData);
      
      return { success: true, user: userData };
    } catch (error) {
      const status = error.response?.status;
      const detail = error.response?.data?.detail;
      const message = status === 429
        ? 'محاولات كثيرة خلال وقت قصير. انتظر دقيقة ثم حاول مجددًا؛ لا يلزم تغيير كلمة المرور.'
        : status === 401
          ? 'اسم المستخدم أو كلمة المرور غير صحيحة'
          : typeof detail === 'string' ? detail
            : 'تعذر تسجيل الدخول حاليًا. حاول مرة أخرى.';
      return { 
        success: false, 
        status,
        error: message
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('rasheedgpt_token');
    setToken(null);
    setUser(null);
  };

  const getAuthHeaders = () => {
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      loading, 
      login, 
      logout, 
      token,
      getAuthHeaders,
      isAuthenticated: !!user 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
